/**
 * @file   : Tracker.js
 * @author :  ()
 * @date   : 7/31/2019, 3:00:41 PM
 */
import PropTypes from 'prop-types'
import React from 'react'

import { isEmpty, isUndefined } from '../../utilities/GeneralUtils'

const Tracker = ({ source = null, cmpLabel = 'Pixel' }) => {
  if (isUndefined(source) || isEmpty(source)) {
    return null
  }

  const imgStyle = { display: 'none' }

  return (
    <img src={source} style={imgStyle} height="1" width="1" alt={cmpLabel} />
  )
}

Tracker.propTypes = {
  source: PropTypes.string.isRequired,
  cmpLabel: PropTypes.string,
}

export default Tracker
